module.exports = __webpack_public_path__ + "img/composer-mic.4540d5eb.svg";